import { useMutation } from 'react-query';

import type { SendVerificationLinkDto, SendVerificationLinkResult } from '@identity/application/dtos';
import { getLinkUseCases } from '@identity/composition';
import { useIdentityFlow } from '@identity/presentation/context';

/**
 * Asks the backend to deliver a verification link through one channel.
 *
 * It updates nothing in the cache: sending a link confirms no value, so there is nothing to mark as
 * met. The polling is what detects the change.
 */
export const useSendVerificationLink = () => {
  const flow = useIdentityFlow();
  const { sendVerificationLink } = getLinkUseCases(flow);

  return useMutation<SendVerificationLinkResult, Error, SendVerificationLinkDto>((dto) =>
    sendVerificationLink.execute(dto),
  );
};
